import { takeLatest, call, put, delay } from 'redux-saga/effects';
import { fetchData, postData } from '../api';
import {
  GET_FITBIT_DATA,
  SYNC_FITBIT_DATA,
  GET_FITBIT_DATA_RANGE,
  GET_LATEST_FITBIT_DATA,
} from './constants';
import {
  getFitbitDataSuccess,
  getFitbitDataError,
  syncFitbitDataSuccess,
  syncFitbitDataError,
  getFitbitDataRangeSuccess,
  getFitbitDataRangeError,
  getLatestFitbitDataSuccess,
  getLatestFitbitDataError,
} from './actions';
import { GET_NUTRITION } from '../Profile/constants';
import { toast } from '../../components/Toast';

export function* getFitbitData() {
  try {
    const token = window.localStorage.token;
    const config = {
      headers: {
        'x-auth-token': token,
      },
    };
    const url = `${process.env.REACT_APP_API_URL}/auth/fitbit/data`;
    const payload = yield call(fetchData, url, config);
    yield put(getFitbitDataSuccess(payload));
  } catch (err) {
    const error = yield err.json();
    console.error('Error fetching Fitbit data:', error);
    yield put(getFitbitDataError(error));
  }
}

export function* syncFitbitData() {
  try {
    const token = window.localStorage.token;
    const url = `${process.env.REACT_APP_API_URL}/auth/fitbit/sync`;
    const config = {
      method: 'POST',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const payload = yield call(fetchData, url, config);
    
    // Check if weight was updated
    if (payload.weightUpdate && payload.weightUpdate.updated) {
      // Weight was updated from Fitbit - refresh nutrition after async calculation
      yield delay(600);
      yield put({ type: GET_NUTRITION });
      
      // Show notification
      toast.success('✅ Weight updated from Fitbit. Your macros have been recalculated.', {
        position: 'top-right',
        duration: 5000,
      });
    }
    
    // After sync, fetch updated data
    yield call(getFitbitData);
    yield put(syncFitbitDataSuccess(payload));
  } catch (err) {
    const error = yield err.json();
    console.error('Error syncing Fitbit data:', error);
    yield put(syncFitbitDataError(error));
  }
}

export function* getFitbitDataRange({ payload: { startDate, endDate } }) {
  try {
    const token = window.localStorage.token;
    const config = {
      headers: {
        'x-auth-token': token,
      },
    };
    const url = `${process.env.REACT_APP_API_URL}/auth/fitbit/data/range?startDate=${startDate}&endDate=${endDate}`;
    const payload = yield call(fetchData, url, config);
    yield put(getFitbitDataRangeSuccess(payload));
  } catch (err) {
    const error = yield err.json();
    console.error('Error fetching Fitbit data range:', error);
    yield put(getFitbitDataRangeError(error));
  }
}

export function* getLatestFitbitData({ payload: { limit } }) {
  try {
    const token = window.localStorage.token;
    const config = {
      headers: {
        'x-auth-token': token,
      },
    };
    const url = `${process.env.REACT_APP_API_URL}/auth/fitbit/data/latest?limit=${limit}`;
    const payload = yield call(fetchData, url, config);
    yield put(getLatestFitbitDataSuccess(payload));
  } catch (err) {
    const error = yield err.json();
    console.error('Error fetching latest Fitbit data:', error);
    yield put(getLatestFitbitDataError(error));
  }
}

export default function* fitbitSaga() {
  yield takeLatest(GET_FITBIT_DATA, getFitbitData);
  yield takeLatest(SYNC_FITBIT_DATA, syncFitbitData);
  yield takeLatest(GET_FITBIT_DATA_RANGE, getFitbitDataRange);
  yield takeLatest(GET_LATEST_FITBIT_DATA, getLatestFitbitData);
}
